import { DataGridV2 } from '@celltrak/ui-components';

import { agenciesHeaders } from '../../constants';
import { getSelectionToClipboard } from '../../../Common/utils';

import useAgenciesList from './hooks';
import styles from './AgenciesList.module.scss';

function AgenciesList() {
  const {
    handleRowClick,
    activeRow,
    handleColumnClick,
    sortByColumn,
    sortDirection,
    isLoading,
    agenciesReports,
  } = useAgenciesList();

  return (
    <div className={styles.gridContainer} onMouseUp={getSelectionToClipboard} role="none">
      <DataGridV2
        rows={agenciesReports}
        headers={agenciesHeaders}
        activeRow={activeRow}
        onRowClick={handleRowClick}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
        loading={isLoading}
        className={styles.fullHeight}
        stickyHeader
      />
    </div>
  );
}

export default AgenciesList;
